import React from 'react';
import { useController } from '@grnhse/seedling/lib/birch/components/forms/form';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack';
import RadioGroup from '@grnhse/seedling/lib/birch/components/radio_group';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix(
  'talent_matching.filter_row.other_active_applications'
);

type OtherActiveApplicationsValue = '1' | '0' | null;

export const OtherActiveApplicationsContent = () => {
  const { field } = useController({ name: 'otherActiveApplications' });

  const selectedValue = (field.value ?? undefined) as '1' | '0' | undefined;

  const handleChange = (value?: string | number) => {
    field.onChange((value ?? null) as OtherActiveApplicationsValue);
  };

  return (
    <Stack spacing={2} direction="column">
      <RadioGroup
        name={field.name}
        ariaLabel={t('description')}
        options={[
          { label: t('radio_include'), value: '1' },
          { label: t('radio_exclude'), value: '0' },
        ]}
        value={selectedValue}
        onChange={handleChange}
        clearable
      />
    </Stack>
  );
};
